module.exports = __webpack_public_path__ + "img/carousel2.aa5e0701.png";